import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';

@Component({
  selector: 'app-popup',
  standalone: true,
  imports: [CommonModule, MaterialModule, FormsModule, ReactiveFormsModule, TranslateModule, TablerIconsModule],
  templateUrl: './popup.component.html',
  styleUrl: './popup.component.scss'
})
export class PopupComponent {

  button: any = [];
  headerText: string = "";
  generalText: string = "";
  subText: string = "";
  type: string = "";
  school: string = "";
  userQrLink: string = "";
  classData: any;
  studyVerified: boolean = false;
  clickedEdit: boolean = false;
  className: string = "";
  selectedClass: any;
  availableClasses: any;
  userOpenedSelect = false;
  selectionAttempted = false;

  //Educators creation
  educatorsData = new FormGroup({
    name: new FormControl({ value: '', disabled: true }),
    numberQRs: new FormControl(0, [Validators.required])});

  //Students creation
  studentsData = new FormGroup({
    name: new FormControl({ value: '', disabled: true }, [Validators.required]),
    numberQRs: new FormControl(0, [Validators.required])});

  //Group selection creation
  groupSelection = new FormGroup({
    study: new FormControl(null, [Validators.required]),
    group: new FormControl(null, [Validators.required])
  });

  //Recover password creation
  userEmail = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email])
  });
    

  constructor(public dialog: MatDialog, private router: Router, public dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: any, private cd: ChangeDetectorRef) {
    
    this.button = data.button;
    this.headerText = data.headerText;
    this.generalText = data.generalText;
    this.type = data.type;

    if(data.school){
      this.school = JSON.parse(JSON.stringify(data.school));
      this.educatorsData.controls.name.setValue(this.school);
    }

    if(data.subText){
      this.subText = JSON.parse(JSON.stringify(data.subText));
    }

    if(data.userQrLink){
      this.userQrLink = JSON.parse(JSON.stringify(data.userQrLink));
    }

    if(data.classData){

      this.classData = JSON.parse(JSON.stringify(data.classData));

      if((this.classData.questionnaireStarted && this.classData.groupAssigned) || this.classData.groupAssigned){
        this.groupSelection.controls['study'].disable();
        this.groupSelection.controls['group'].disable();
      }

      if(this.classData.study!==null){
        this.groupSelection.controls.study.setValue(this.classData.study);
      }

      if(this.classData.group && this.classData.group!==0){
          this.groupSelection.controls.group.setValue(this.classData.group);
      }
    }

    if(data.className){
      this.className = JSON.parse(JSON.stringify(data.className));
    }

    if(data.selectedClass){
      this.selectedClass = JSON.parse(JSON.stringify(data.selectedClass));
      this.studentsData.controls.name.setValue(this.selectedClass.course +"º"+this.selectedClass.name);
    }

    if(data.availableClasses){
      this.studentsData.controls.name.enable();
      this.availableClasses = JSON.parse(JSON.stringify(data.availableClasses));
    }

  }

  onOpened() {
    this.userOpenedSelect = true;
  }
  
  onClosed() {
    if (!this.studentsData.get('name')?.value) {
      this.selectionAttempted = true;
    }
  }

    get userEmailControls() {
    return this.userEmail.controls;
  }



    /**
   * Method called when the popup is closed
   * @param buttonClicked button clicked to close
   */
    close(buttonClicked: any) {
      this.dialogRef.close({ data: buttonClicked });
    }

    /**
     * Method to close to create students
     * @param classId 
     * @param qrCodesNumber 
     */
    closeStudentsCreation(classId: any, qrCodesNumber: any) {

      let classSelected = this.availableClasses.filter((item: any) => Number(item.classId) == Number(classId));

      this.dialogRef.close({ data: {classId: classId, className: classSelected[0].name, consentType: classSelected[0].consentType, qrCodesNumber: qrCodesNumber} });
    }

    /**
     * Method to save the group selection
     */
    saveGroupSelection() {

      this.studyVerified = true;

      if(this.groupSelection.controls.study.value!=null && this.groupSelection.controls.group.value!=null && this.groupSelection.controls.group.value!=0){
   
        this.dialogRef.close({ data: {
          study: this.groupSelection.controls.study.value,
          group: this.groupSelection.controls.group.value
        }  });
      }

    }

    /**
     * Method to enable the group edition
     */
    editGroupSelection() {
        this.clickedEdit=true;
        this.groupSelection.controls['study'].enable();
        this.groupSelection.controls['group'].enable();
    }
}
